/**
 * Inherits the button's own text colour, so it reads correctly on the orange,
 * navy and outline chassis alike. The previous SVG painted its track `#fff`
 * and its arc via `currentFill` (a Flowbite-ism with no CSS meaning here), and
 * was wrapped in a `w-full` grid that pushed the label off-centre.
 */
const ButtonSpinner = () => (
  <svg
    role="status"
    aria-hidden="true"
    className="h-4 w-4 shrink-0 animate-spin"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-90"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    />
  </svg>
);

export default ButtonSpinner;
